import { z } from "zod";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";

const busEditInputSchema = z.object({
  name: z.string().min(1, { message: "バス名を入力してください。" }),
  capacity: z.coerce
    .number()
    .min(1, { message: "定員は1以上の数値を入力してください。" }),
});

const BusEditForm = ({ selectedBus, onSubmit, isSubmitting, onCancel }) => {
  return (
    <Form
      onSubmit={onSubmit}
      options={{
        defaultValues: {
          name: selectedBus?.name || "",
          capacity: selectedBus?.capacity || "",
        },
      }}
      schema={busEditInputSchema}
    >
      {({ register, formState }) => {
        return (
          <>
            <div className="d-flex gap-2">
              <div className="w-50">
                <Input
                  type="text"
                  label="バス名"
                  name="name"
                  error={formState.errors["name"]}
                  registration={register("name")}
                  placeholder="バス名を入力"
                />
              </div>
              <div className="w-50">
                <Input
                  type="number"
                  label="定員"
                  name="capacity"
                  error={formState.errors["capacity"]}
                  registration={register("capacity")}
                  placeholder="定員を入力"
                />
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-end mt-3">
              <button
                className="btn btn-secondary px-4"
                onClick={onCancel}
                type="button"
              >
                閉じる
              </button>
              <button
                className="btn btn-primary px-4"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "処理中..." : selectedBus ? "確認" : "追加"}
              </button>
            </div>
          </>
        );
      }}
    </Form>
  );
};

export default BusEditForm;
